import styled from 'styled-components';

import media from '../../styles/media.style';
import { PAGE_WIDTH } from '../../styles/variables.style';

export const Pillar = styled.div`
  margin-top: 15px;
  width: 100%;

  ${media.tabletP`
    width: calc((100% - 20px) / 2);
  `};

  ${media.tabletL`
    width: calc((100% - 60px) / 4);
  `};
`;

export const Actions = styled.div`
  align-items: center;
  background-color: black;
  color: white;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  height: 80px;
  justify-content: space-between;
  letter-spacing: 0.8px;
  padding: 0 25px;
  position: relative;
  width: 100%;
`;

export const Overlay = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
`;

export const OverlayContent = styled.div`
  background-color: white;
  height: 100%;
  max-width: ${PAGE_WIDTH}px;
  overflow-y: scroll;
  position: relative;
  width: 100%;
  z-index: 202;

  ${media.tabletP`
    display: flex;
    height: unset;
    justify-content: center;
    overflow-y: unset;
  `};
`;

export const Details = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  padding: 20px;

  ${media.tabletL`
    padding: 100px;
  `};

  ${media.desktop`
    padding: 130px;
  `};
`;

export const Shadow = styled.div`
  background-color: black;
  height: 100%;
  opacity: 0.5;
  position: absolute;
  width: 100%;
  z-index: 201;
`;

export const ButtonContainer = styled.div`
  align-items: center;
  background-color: white;
  border-radius: 30px;
  box-shadow: 0 0 20px -5px black;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 5px;
  position: fixed;
  right: 20px;
  top: 20px;

  ${media.tabletL`
    box-shadow: none;
    position: absolute;
    right: 50px;
    top: 50px;
  `};
`;

export const CloseButton = styled.img`
  transform: rotate(45deg);
`;

export const MarkdownStyle = styled.div`
  max-width: 430px;

  h1 {
    font-size: 30px;
    font-weight: 500;
    line-height: 1.26;
    letter-spacing: 0.4px;
    margin: 0;

    ${media.tabletL`
      font-size: 38px;
    `};
  }

  h2 {
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: 0.1px;
    margin: 35px 0 0;
  }

  p {
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.1px;
    margin: 12px 0 0;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/BrandPillar.style.js